import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  public nodeChange = new Subject<any>();
  activeNode = null;
  public unAttemptedQuestions = new BehaviorSubject<any[]>([]);
  // activeNode = null;
  lastQuestionId:string;
  constructor() { }

  changeNode(node) {
    this.activeNode = node;
    this.nodeChange.next(node);
  }

  setUnAttemptedAnswerArray(val) {
    this.unAttemptedQuestions.next(val)
  }

  setLastQuestionId(val){
    this.lastQuestionId = val;
  }

  getLastQuestionId(){
    return this.lastQuestionId;
  }

}
